import React, { useEffect } from 'react'
import { useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, Tabs, Skeleton } from 'antd'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { Table, Tag } from 'antd';
import TableView from '../../../../contents/AntTableResponsive';
import { DeleteOutlined, DownloadOutlined, EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import Column from 'rc-table/lib/sugar/Column';
import { render } from '@testing-library/react';
import { SelectClassConfig } from '../../../select/SelectClassConfig';
import { v4 as uuidv4 } from "uuid";
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf } from '../../../utils/pdf';
import { FilePdfOutlined } from '@ant-design/icons';
import { SelectSection } from '../../../select/SelectSection';
import { SelectAcademicYear } from '../../../select/SelectAcademicYear';
require('jspdf-autotable');

export default function ExamReportSectionWiseResult() {
    const { Option } = Select;
    const [examReportSectionWiseResultForm] = Form.useForm();

    const fetchExamListByclassConfigIdSectionWiseExam = useStoreActions((state) => state.exam.fetchExamListByclassConfigIdSectionWiseExam);
    const examListByclassConfigIdSectionWiseExam = useStoreState((state) => state.exam.examListByclassConfigIdSectionWiseExam);

    const fetchSectionResultByAcademicYearClassConfigIdExamConfigId = useStoreActions((state) => state.exam.fetchSectionResultByAcademicYearClassConfigIdExamConfigId);
    const sectionResultByAcademicYearClassConfigIdExamConfigId = useStoreState((state) => state.exam.sectionResultByAcademicYearClassConfigIdExamConfigId);

    const unassignedSubjectMarkListColumn = [
        { title: 'Student ID', dataIndex: 'customStudentId', key: "customStudentId", showOnResponse: true, showOnDesktop: true },
        { title: 'Sudent Name', dataIndex: 'studentName', key: "studentName", showOnResponse: true, showOnDesktop: true },
        { title: 'Student Roll', dataIndex: 'studentRoll', key: "studentRoll", showOnResponse: true, showOnDesktop: true },
        { title: 'Total Marks', dataIndex: 'totalMarks', key: "totalMarks", showOnResponse: true, showOnDesktop: true },
        { title: 'Section Position', dataIndex: 'sectionPosition', key: "sectionPosition", showOnResponse: true, showOnDesktop: true },
        { title: 'Grade', dataIndex: 'gradingPoint', key: "gradingPoint", showOnResponse: true, showOnDesktop: true },
        { title: 'CGPA', dataIndex: 'letterGrade', key: "letterGrade", showOnResponse: true, showOnDesktop: true },
        { title: 'Status', dataIndex: 'resultStatus', key: "resultStatus", showOnResponse: true, showOnDesktop: true },
        { title: 'Total Failed Subjects', dataIndex: 'numberOfFailedSubjects', key: "numberOfFailedSubjects", showOnResponse: true, showOnDesktop: true },
    ];
    const loading = useStoreState((state) => state.exam.loading);

    function exportPdf() {

        var doc = new jsPDF("l", "mm", "a4");

        var details = `Section Wise Result`;
        pdfDataL(doc, "");
        doc.text(details, 150, 40, 'center');
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // FOOTER
            var str = ppowerdbypdf + data.pageCount;
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp + pdatepdf;
            }
            doc.setFontSize(8);
            var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            doc.text(str, data.settings.margin.right, pageHeight - 10);
        };


        var col = [
            "Student ID",
            "Sudent Name",
            "Student Roll",
            "Total Marks",
            "Section Position",
            "Grade",
            "CGPA",
            "Status",
            "Total Failed Subjects"
        ].filter(Boolean);

        var rows: any = [];


        sectionResultByAcademicYearClassConfigIdExamConfigId.forEach(element => {
            var temp: any = [
                element.customStudentId,
                element.studentName,
                element.studentRoll,
                element.totalMarks,
                element.sectionPosition,
                element.gradingPoint,
                element.letterGrade,
                element.resultStatus,
                element.numberOfFailedSubjects
            ];
            rows.push(temp);
        });


        let first = doc.autoTable.previous;
        doc.autoTable([
            { title: "", dataKey: "b1" },
            { title: "", dataKey: "b2" },
            { title: "", dataKey: "b3" },
            { title: "", dataKey: "b4" },
            { title: "", dataKey: "b5" },
            { title: "", dataKey: "b6" },
        ], [
            {
                b1: "Academic Year",
                b2: $(".yearSelect").text(),
                b3: 'Section',
                b4: $(".sectionSelect").text(),
                b5: 'Exam',
                b6: $(".examSelectx").text(),
            }
        ], {
            startY: 45,
            showHeader: "never",
            theme: 'grid',

            // addPageContent: pageContent,
        });
        doc.autoTable(col, rows, {
            startY: doc.autoTable.previous.finalY + 5,
            showHeader: "firstPage",
            theme: 'grid',
            headerStyles: {
                // fillColor: [105, 105, 105],
                // textColor: [255, 255, 255],
                // fontSize: 10
                lineWidth: .01,
                lineColor: [224, 224, 224]
            },
            columnStyles: {
                ledgerName: {
                    halign: "left",
                    fontSize: 8,
                    columnWidth: 75
                },
                debit: {
                    halign: "right",
                    fontSize: 8,
                    columnWidth: 53.4
                },
                credit: {
                    halign: "right",
                    fontSize: 8,
                    columnWidth: 53.4
                }
            },


        });


        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        doc.setPage(1 + doc.internal.getCurrentPageInfo().pageNumber - doc.autoTable.previous.pageCount);
        doc.save(details + ".pdf");

    }

    const onChangeClassList = (e) => {
        fetchExamListByclassConfigIdSectionWiseExam(e);
    }

    const examReportSearch = (value) => {
        let postData: any = {
            examConfigId: value.selectExam,
            classConfigId: value.sectionSection,
            academicYear: value.sectionYear
        }
        fetchSectionResultByAcademicYearClassConfigIdExamConfigId(postData);
    }

    return (
        <>
            <Card title="Section Wise Result">
                <Row>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 18, offset: 3 }} xl={{ span: 18, offset: 3 }}>
                        <Form
                            layout="vertical"
                            id="sessionYearInfo"
                            onFinish={examReportSearch}
                            form={examReportSectionWiseResultForm}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                                    <Form.Item
                                        name="sectionYear"
                                        label="Select Year"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select year" },
                                        ]}
                                    >
                                        <SelectAcademicYear />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                                    <Form.Item
                                        name="sectionSection"
                                        label="Select Section"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select section" },
                                        ]}
                                    >
                                        <SelectClassConfig onChange={(e) => onChangeClassList(e)} />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                                    <Form.Item
                                        name="selectExam"
                                        label="Select Exam"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select exam" },
                                        ]}
                                    >
                                        <Select placeholder="Exam List" style={{ width: "100%" }} className="examSelectx">
                                            {examListByclassConfigIdSectionWiseExam ? (
                                                examListByclassConfigIdSectionWiseExam.map((type, idx) => (
                                                    <Option key={type.examConfigId} value={type.examConfigId}>
                                                        {type.examName}
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option value="fetching">Fetching exam</Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Skeleton loading={loading} paragraph={{ rows: 10 }} />
                <Row style={{ display: sectionResultByAcademicYearClassConfigIdExamConfigId.length > 0 ? '' : 'none' }}>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }}>
                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns: unassignedSubjectMarkListColumn,
                                rowKey: "subjectSerial",
                                dataSource: sectionResultByAcademicYearClassConfigIdExamConfigId,
                                filterData: sectionResultByAcademicYearClassConfigIdExamConfigId,
                                pagination: true,
                                bordered: true
                            }}
                            mobileBreakPoint={768}
                        />
                        <br />
                        <Button type="primary" htmlType="submit" icon={<DownloadOutlined />} onClick={() => exportPdf()} className="float-right">Download</Button>
                    </Col>
                </Row>
            </Card>
        </>
    )

}